import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    UserNavBarItem: () => import("./components/navbar/UserNavBarItem.vue"),
    SwitcherNavBarItem: () => import("./components/navbar/SwitcherNavBarItem.vue"),
    MessageNavBarItem: () => import("./components/navbar/MessageNavBarItem.vue"),
    MessageIframe: () => import("./components/MessageIframe.vue"),
    UserProfileTile: () => import("./components/tile/UserProfileTile.vue"),
    HelperButton: () => import("./components/HelperButton.vue"),

    SingleTileContainer: () => import("./components/SingleTileContainer.vue"),
};

export default globals;
